var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-update" }, [
    _c(
      "div",
      {
        staticClass: "product-update-btn",
        class: { active: _vm.isActive },
        on: {
          click: _vm.handleClick,
          mouseenter: function ($event) {
            _vm.isHover = true
          },
          mouseleave: function ($event) {
            _vm.isHover = false
          },
        },
      },
      [
        _c("div", { staticClass: "update-icon-wrapper" }, [
          _c("img", {
            staticClass: "update-icon",
            attrs: { src: _vm.currentIcon, alt: "产品更新" },
          }),
          _vm.hasUpdate
            ? _c("span", {
                staticClass: "update-dot",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleDotClick.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
        ]),
        _c("span", { staticClass: "update-text" }, [_vm._v("产品更新")]),
      ]
    ),
    _c("iframe", {
      ref: "productIframe",
      staticClass: "product-iframe",
      attrs: {
        src: "https://testdocumentation.aifxy.com/document",
        frameborder: "0",
      },
      on: { load: _vm.onIframeLoad },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }